import(/* webpackMode: "eager" */ "/codebuild/output/src216873376/src/simulator-infinily/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src216873376/src/simulator-infinily/src/app/_components/SplashScreenForm.tsx");
